import { BlogPostWizard } from 'components/Wizards/BlogPostWizard/BlogPostWizard'
import { BlogPostWizardProps, InitialValues } from 'components/Wizards/BlogPostWizard/Types'
import Styles from 'components/Wizards/RetryWizard/RetryWizard.module.scss'
import cx from 'classnames'
import { AlmanacFile } from 'types'
import { GenerateNewDocButton } from './GenerateNewDocButton'
import { Button } from 'components/Button'

interface Props
  extends Omit<
    BlogPostWizardProps,
    | 'initialValues'
    | 'articleId'
    | 'layerId'
    | 'nodeSelection'
    | 'bodyClassName'
    | 'stepperVariant'
    | 'headerClassName'
    | 'BlogPostWizardProps'
  > {
  articleId: string
  layerId: string
  initialValues: {
    project: AlmanacFile
  } & Partial<InitialValues>
}

export const RetryBlogPostWizard = ({ initialValues, onSuccess, ...props }: Props) => {
  return (
    <BlogPostWizard {...props} initialValues={initialValues}>
      {({ submitForm, isSubmitting }) => (
        <div className={cx(Styles.buttonContainer, Styles.rightButtons)}>
          <GenerateNewDocButton onSubmit={submitForm} project={initialValues.project} isDisabled={isSubmitting} />
          <Button size="lg" onPress={() => submitForm()} isDisabled={isSubmitting}>
            Try Again on This Doc
          </Button>
        </div>
      )}
    </BlogPostWizard>
  )
}
